module.exports = __webpack_public_path__ + "static/img/new_ad2.719325f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_ad2.jpg
// module id = yNKZ
// module chunks = 1